/**
 * Viewer read-only gating. A "viewer" is a free, read-only seat (pricing rework
 * WS1). The database is the authoritative boundary — migration 0058 makes every
 * write RLS policy require a non-viewer — these hooks just let the UI reflect it
 * (hide/disable write controls, show a read-only banner).
 *
 * Defaults to editable when the role is unknown or in local/demo mode (activeOrg
 * is null), so nothing is gated off unless the user is explicitly a viewer.
 */
import { useProjectStore } from '@/store/useProjectStore';

export function useCanEdit(): boolean {
  const activeOrg = useProjectStore((s) => s.activeOrg);
  return activeOrg?.role !== 'viewer';
}

export function useIsViewer(): boolean {
  return !useCanEdit();
}
